import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAssessment } from '../context/AssessmentContext';
import PersonalInfoForm from '../components/forms/PersonalInfoForm';

const HomePage = () => {
  const navigate = useNavigate();
  const { startAssessment } = useAssessment();
  
  const handleFormSubmit = async (personalData) => {
    try {
      const assessmentId = await startAssessment(personalData);
      console.log('Assessment started:', assessmentId);
      navigate('/assessment');
    } catch (error) {
      console.error('Error starting assessment:', error);
      throw error;
    }
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800">
      {/* Dashboard Link */}
      <div className="absolute top-4 right-4">
        <button
          onClick={() => navigate('/dashboard')}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
        >
          📊 View Dashboard
        </button>
      </div>
      
      <PersonalInfoForm onSubmit={handleFormSubmit} />
    </div>
  );
};

export default HomePage;
